import { useCallback, useEffect, useState } from "react";
import { validateCart } from "../services/publicApi";

function buildCartPayload({ cartItems, fulfillmentType, selectedLocation }) {
  return {
    location_slug: selectedLocation?.slug || cartItems[0]?.locationSlug || "",
    fulfillment_type: fulfillmentType,
    items: cartItems.map((item) => ({
      menu_item_id: item.menu_item_id || item.id,
      quantity: item.quantity,
      unit_price: item.price,
      customer_note: item.customer_note || "",
      selected_options: item.selected_options || [],
    })),
  };
}

export function useCartValidation({ cartItems, fulfillmentType = "pickup", selectedLocation }) {
  const [cartResult, setCartResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const runValidation = useCallback(async () => {
    if (!cartItems.length || !selectedLocation) {
      setCartResult(null);
      setError("");
      return null;
    }

    setLoading(true);
    setError("");

    try {
      const payload = buildCartPayload({ cartItems, fulfillmentType, selectedLocation });
      const result = await validateCart(payload);
      setCartResult(result);
      return result;
    } catch (requestError) {
      const payload = requestError.payload || null;

      if (payload?.errors) {
        setCartResult(payload);
        setError("");
        return payload;
      }

      setError(requestError.message || "We could not validate your cart.");
      return null;
    } finally {
      setLoading(false);
    }
  }, [cartItems, fulfillmentType, selectedLocation]);

  useEffect(() => {
    runValidation();
  }, [runValidation]);

  return {
    cartResult,
    error,
    loading,
    runValidation,
  };
}

export { buildCartPayload };
